<template>
    <nav class="navbar navbar-expand-lg fixed-top">
        <!--<button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>-->
        <div class="row w-100 align-items-center">
            <div class="col-2">
                <i class="fa fa-bars clickable p-2 text-danger" @click="onToggleSidebarClicked"></i>
            </div>
            <div class="col-8 text-center">
                <!--                <h4 class="m-0">Iran Cups</h4>-->
                <img src="/img/logo/logo.png" class="img-fluid logo">
            </div>
            <div class="col-2">
                <ul class="navbar-nav justify-content-end p-0">
                    <li class="nav-item active">
                        <a  class="nav-link text-center" @click="logout">
                            <i class="fa fa-power-off text-danger"></i>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <!--<div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ml-auto">
                <li class="nav-item active">
                    <router-link to="/settings" class="nav-link">تنظیمات</router-link>
                </li>
            </ul>
        </div>-->
    </nav>
</template>

<script>
    import EventBus from "../_framework/event-bus";
    import * as $ from "jquery";

    export default {
        name: 'navbar',
        mounted() {
            if ($(window).width() < 991) {
                $(".sidebar").removeClass("open");
                $(".wrapper").addClass("wide");
            }
        },
        methods: {
            onToggleSidebarClicked() {
                $(".sidebar").toggleClass("open");
                $(".wrapper").toggleClass("wide");
                if ($(".sidebar").hasClass("open") && $(window).width() < 991) {
                    $(".navbar").removeClass("navbar-color").removeClass("shadow");
                } else {
                    if ($(window).scrollTop() > 62) {
                        $(".navbar").addClass("navbar-color").addClass("shadow");
                    }
                }
            },
            logout() {
                localStorage.removeItem('userName');
                localStorage.removeItem("mobile");
                localStorage.removeItem('token');
                localStorage.removeItem('userId');
                // console.log("logout");
                // this.$router.push({name: "login"});
                this.$router.push({name: 'login', query: {unauthorized: true}});
            }
        }
    }
</script>